import { useState, useEffect } from "react";
import Sidebar from "../Sidebar/sidebar";
import Dashboard from "./ChatDashboard";

function LandingPage() {
  const [activeSessionId, setActiveSessionId] = useState(null);
  const [newSession, setNewSession] = useState(true);
  const [refreshSessions, setRefreshSessions] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [sessions, setSessions] = useState([]);

  // Listen for when Sidebar has finished loading sessions
  useEffect(() => {
    const handleSidebarReady = () => {
      // Sidebar has finished loading sessions; show the landing view.
      setIsInitialLoad(false);
    };

    window.addEventListener('sidebarReady', handleSidebarReady);

    // Fallback timeout in case event doesn't fire
    const timeout = setTimeout(() => {
      setIsInitialLoad(false);
    }, 3000);

    return () => {
      window.removeEventListener('sidebarReady', handleSidebarReady);
      clearTimeout(timeout);
    };
  }, []);

  // Listen for sessions updates from Sidebar
  useEffect(() => {
    const handleSessionsUpdated = (event) => {
      const { sessions: updatedSessions } = event.detail || {};
      if (updatedSessions) {
        setSessions(updatedSessions);
      }
    };

    window.addEventListener('sessionsUpdated', handleSessionsUpdated);

    return () => {
      window.removeEventListener('sessionsUpdated', handleSessionsUpdated);
    };
  }, []);

  const handleNewSessionCreated = (sessionId, firstMessage) => {
    // Set the new session as active
    setActiveSessionId(sessionId);
    setNewSession(false);

    // Dispatch event to update Sidebar - Sidebar will fetch sessions from backend
    // to maintain consistent ordering
    const newSessionItem = {
      id: sessionId,
      sessionName: firstMessage || "New session",
    };
    
    window.dispatchEvent(new CustomEvent('newSessionAdded', { 
      detail: { 
        session: newSessionItem,
        activeSessionId: sessionId
      } 
    }));
  };

  if (isInitialLoad) {
    return (
      <div className="app-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '48px', 
            height: '48px', 
            border: '4px solid #E5E7EB', 
            borderTopColor: '#B90005', 
            borderRadius: '50%', 
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <p style={{ color: '#6B7280', fontSize: '14px' }}>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <Sidebar
        activeSessionId={activeSessionId}
        setActiveSessionId={setActiveSessionId}
        setNewSession={setNewSession}
        refreshSessions={refreshSessions}
        isCollapsed={isSidebarCollapsed}
      />
      <Dashboard
        activeSessionId={activeSessionId}
        setActiveSessionId={setActiveSessionId}
        newSession={newSession}
        setNewSession={setNewSession}
        onNewSessionCreated={handleNewSessionCreated}
        isSidebarCollapsed={isSidebarCollapsed}
        setIsSidebarCollapsed={setIsSidebarCollapsed}
      />
    </div>
  );
}

export default LandingPage;
